import React from "react";
import { ICommonIconProps } from "../interface";

const MailIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width={props?.IconWidth || "30"}
      height={props?.IconHeight || "30"}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4388 16.2451L16.9262 18.7662C15.9073 19.7886 14.1146 19.8107 13.0737 18.7662L10.561 16.2451L1.53662 25.2988C1.87254 25.4541 2.24291 25.5468 2.63666 25.5468H27.3632C27.757 25.5468 28.1272 25.4542 28.463 25.2988L19.4388 16.2451Z"
        fill={props?.IconColor || "currentColor"}
      />
      <path
        d="M27.3633 4.45312H2.63672C2.24297 4.45312 1.8726 4.54582 1.5368 4.70115L11.18 14.3763C11.1806 14.377 11.1814 14.3771 11.182 14.3777C11.1824 14.3782 11.1827 14.3787 11.1828 14.3793L14.3183 17.5252C14.6514 17.8582 15.3487 17.8582 15.6818 17.5252L18.8167 14.3798C18.8167 14.3798 18.8174 14.3784 18.8181 14.3777C18.8181 14.3777 18.8195 14.377 18.8201 14.3763L28.4631 4.70109C28.1273 4.5457 27.757 4.45312 27.3633 4.45312ZM0.28043 5.93039C0.106641 6.28184 0 6.67195 0 7.08984V22.9102C0 23.328 0.106523 23.7182 0.280371 24.0696L9.32039 15.0003L0.28043 5.93039ZM29.7196 5.93027L20.6797 15.0003L29.7196 24.0697C29.8934 23.7183 30 23.3282 30 22.9102V7.08984C30 6.67184 29.8934 6.28172 29.7196 5.93027Z"
        fill={props?.IconColor || "currentColor"}
      />
    </svg>
  );
};

export default MailIcon;
